export default "__VITE_ASSET__CsIbLssD__"